import { Controller } from 'stimulus'
import Bloodhound from 'bloodhound-js'
import Mustache from 'mustache'

export default class extends Controller {

  static targets = ['input', 'icon', 'loading', 'template', 'results', 'noResults', 'selectable', 'default']

  connect() {
    Mustache.parse(this.templateTarget.innerHTML)
    this.bloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: (`${ this.element.dataset.url }?autocomplete=true&per_page=5&q=%QUERY`),
        wildcard: '%QUERY'
      }
    })
  }

  showDefault() {
    if (this.hasDefaultTarget) this.defaultTarget.classList.remove('dn')
  }

  hideDefault() {
    if (this.hasDefaultTarget) this.defaultTarget.classList.add('dn')
  }

  focusInput() {
    this.inputTarget.focus()
  }

  keydown(event) {
    if (event.key == 'Escape') {
      event.preventDefault()
      this.hide()
    }
    if (event.key == 'ArrowDown') {
      event.preventDefault()
      if (this.resultsTarget.classList.contains('dn') && this.element.dataset.emptySearch) {
        this.show()
      } else {
        this._moveSelectionDown()
      }
    }
    if (event.key == 'ArrowUp') {
      event.preventDefault()
      this._moveSelectionUp()
    }
    if (event.key == 'Enter' && this.selectables[this.selectedIndex]) {
      event.preventDefault()
      this._clickSelection()
    }
  }

  hide() {
    this.inputTarget.value = ''
    this.hideNoResults()
    this.resultsTarget.classList.add('dn')
    this.hideDefault()
  }

  hideNoResults(){
    this.noResultsTarget.classList.add('dn')
  }

  search(event) {
    event.stopPropagation()
    this.hideNoResults()
    if (this.inputTarget.value.length > 0 || this.element.dataset.emptySearch) {
      this.hideDefault()
      this.loadingTarget.classList.remove('dn')
      this.iconTarget.classList.add('dn')
      this.bloodhound.search(this.inputTarget.value, this.sync, this.async)
    } else {
      this.resultsTarget.innerHTML = ''
      this.resultsTarget.classList.add('dn')
      this.showDefault()
    }
  }

  show(event) {
    if (this.resultsTarget.innerHTML == '') {
      this.async([])
      this.search(event)
    }
    this.resultsTarget.classList.remove('dn')
  }

  sync() {}

  hideIfClickedOutside = (event) => {
    if (!this._isDescendant(this.resultsTarget, event.target) && this.inputTarget != event.target) {
      this.hide()
    }
  }

  _isDescendant(parent, child) {
    let node = child.parentNode
    while (node != null) {
      if (node == parent) {
        return true
      }
      node = node.parentNode
     }
     return false
   }

  async = (results) => {
    this.loadingTarget.classList.add('dn')
    this.iconTarget.classList.remove('dn')
    if (results.length == 0 || (this.inputTarget.value.length == 0 && !this.element.dataset.emptySearch)) {
      this.resultsTarget.innerHTML = ''
      this.noResultsTarget.classList.remove('dn')
      this.resultsTarget.classList.add('dn')
    } else {
      let rendered = Mustache.render(this.templateTarget.innerHTML, { results: results })
      this.resultsTarget.innerHTML = rendered
      this.resultsTarget.classList.remove('dn')
      this.selectedIndex = -1
    }
  }

  _moveSelectionUp() {
    this.selectedIndex--
    if (this.selectedIndex < 0) this.selectedIndex = this.selectables.length - 1
    this._highlightSelection()
  }

  _moveSelectionDown() {
    this.selectedIndex++
    if (this.selectedIndex >= this.selectables.length) this.selectedIndex = 0
    this._highlightSelection()
  }

  _clearSelection() {
    for(let selectable of this.selectables) {
      selectable.classList.remove(this.highlight_class)
    }
  }

  _highlightSelection() {
    this._clearSelection()
    if (this.selectables[this.selectedIndex]) {
      this.selectables[this.selectedIndex].classList.add(this.highlight_class)
    }
  }

  _clickSelection() {
    if (this.selectables[this.selectedIndex]) {
      this.selectables[this.selectedIndex].click()
    } else {
      if (this.selectables[0]) this.selectables[0].click()
    }
  }

  get selectables() {
    return this.selectableTargets.filter(selectable => selectable.offsetParent !== null)
  }

  get highlight_class() {
    return this.data.get("highlight-class") || 'bg-black-10'
  }

  get selectedIndex() {
    return parseInt(this.data.get('selectedIndex') || -1)
  }

  set selectedIndex(value) {
    this.data.set('selectedIndex', value)
  }
}
